module.exports = __webpack_public_path__ + "img/hero.d130a1f9.png";